export const searchCompaniesActionTypes = {
    'PAGE_INIT': 'SEARCH_COMPANIES_PAGE_INIT',
    'PAGE_NEXT': 'SEARCH_COMPANIES_PAGE_NEXT',
    'PAGE_PREVIOUS': 'SEARCH_COMPANIES_PAGE_PREVIOUS',
    'PAGE_REQUEST': 'SEARCH_COMPANIES_PAGE_REQUEST',
    'PAGE_SUCCESS': 'SEARCH_COMPANIES_PAGE_SUCCESS',
    'PAGE_ERROR': 'SEARCH_COMPANIES_PAGE_ERROR',
    'TOGGLE_SELECTION': 'SEARCH_COMPANIES_TOGGLE_SELECTION',
    'CLEAR_SELECTION': 'SEARCH_COMPANIES_CLEAR_SELECTION',
    'TOGGLE_ALL': 'SEARCH_COMPANIES_TOGGLE_ALL',
    'ADD_FILTER': 'SEARCH_COMPANIES_ADD_FILTER',
    'REMOVE_FILTER': 'SEARCH_COMPANIES_REMOVE_FILTER',
};
